module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1612878424-2.1.11/node_modules/axios/index.js
// module id = 228
// module chunks = 0